import {
  FETCH_TEMPLATE_REQUEST, FETCHING_TEMPLATE_SUCCEEDED, FETCHING_TEMPLATE_FAILED,
} from 'constants/actionTypes';

import _ from 'lodash';

const initialState = {
  loading: false,
  items: []
}

export function templateReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TEMPLATE_REQUEST: 
      return {
        ...state,
        loading: true
      }

    case FETCHING_TEMPLATE_SUCCEEDED: 
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [...state.items, ...records];
      } else {
        items = records
      }

      items = _.uniqBy(items, 'id');

      return {
        ...state,
        loading: false,
        items: items,
        pagination: {
          ...state.pagination,
          current: action.payload.currentPage,
          totalPages: action.payload.totalPages,
          totalRecordsCount: action.payload.totalRecordsCount
        }
      }

    case FETCHING_TEMPLATE_FAILED:
      return {
        ...state,
        loading: false,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}